import { useEffect } from "react";
import { Outlet } from "react-router";

// Minimal shell for /embed/* routes. These are iframed from third-party
// origins (partner sites embedding a form) so the layout strips all chrome
// and forces a transparent body background so host pages can style around
// the iframe.
export function EmbedLayout() {
  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = "transparent";
    return () => {
      document.body.style.background = prev;
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
